export function menuSidebar() {
  return {
    type: '@dash/MENU_SIDEBAR',
  };
}
